/**
 * Marketing waitlist social-proof response contract.
 *
 * The www BFF returns `{ count }` when AUTHORYTHM_API_URL is set, or
 * `{ unavailable: true }` when it is not (local/CI without a SaaS origin).
 * There is no default host in application code.
 */
export class WaitlistCountUnavailableError extends Error {
  override readonly name = "WaitlistCountUnavailableError"

  constructor() {
    super("Waitlist count unavailable")
  }
}

type WaitlistCountBody = {
  count?: unknown
  error?: unknown
  unavailable?: unknown
}

export function parseWaitlistCountResponse(status: number, body: WaitlistCountBody): number {
  if (body.unavailable === true) {
    throw new WaitlistCountUnavailableError()
  }

  if (status < 200 || status >= 300) {
    const detail =
      typeof body.error === "string"
        ? body.error
        : body.error != null
          ? JSON.stringify(body.error)
          : `waitlist-count request failed (${status})`
    throw new Error(detail)
  }

  if (typeof body.count !== "number" || !Number.isFinite(body.count) || body.count < 0) {
    throw new Error(`Invalid waitlist count payload: ${JSON.stringify(body)}`)
  }

  return Math.floor(body.count)
}
